import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=64a5ddea&"
import script from "./Customers.vue?vue&type=script&lang=js&"
export * from "./Customers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a5ddea')) {
      api.createRecord('64a5ddea', component.options)
    } else {
      api.reload('64a5ddea', component.options)
    }
    module.hot.accept("./Customers.vue?vue&type=template&id=64a5ddea&", function () {
      api.rerender('64a5ddea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Customers.vue"
export default component.exports